/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaReportIntestazioneDTO { 
    studente_id?: string;
    studente_nome?: string;
    studente_cognome?: string;
    studente_codice_fiscale?: string;
    genitore_nome?: string;
    genitore_cognome?: string;
    genitore_email?: string;
    genitore_codice_fiscale?: string;
    scuola_id?: string;
    scuola_nome?: string;
    scuola_plesso_padiglione?: string;
}

